






























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { validation as formValidate } from '@/views/Onboarding/Steps/LoyaltySetup/validation';

import Typography from '@/components/atoms/Typography/Typography.vue';
import ConfigRadio from '@/components/molecules/ConfigRadio/ConfigRadio.vue';
import { configFormDataFactory } from '@/views/Onboarding/helpers';
import { ConfigFormData, ConfigFormDataValueType } from '@/models/onboarding';

@Component({
  components: {
    Typography,
    ConfigRadio
  }
})
export default class LoyaltyConfigForm extends Vue {
  @Prop() defaultFormData?: ConfigFormData;
  @Prop() defaultLoyaltyValues?: number[];
  @Prop() customLabelDescription?: string;
  @Prop() disabled?: boolean;

  formData = this.defaultFormData || this.getInitialFormData();
  defaultValues = this.defaultLoyaltyValues || this.defaultValuesForm;

  get tPrefix() {
    return 'common.components.loyaltyConfigForm';
  }

  get isActiveCustomRadio() {
    const { customValue, customValueFocused } = this.formData;

    const valueIsNumber = typeof customValue === 'number';

    return valueIsNumber && !customValueFocused;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessRegistrations() {
    return this.$store.getters['registration/getBusinessRegistration'] || [];
  }

  get alreadySetRewardRate() {
    return this.businessRegistrations
      .filter(
        (registration: any) =>
          registration.businessSignupSteps[0].status === 'seen'
      )
      .map(({ slug }: any) => slug)
      .includes('manage-rewards');
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get defaultValuesForm() {
    return [3, 5, 7, 10, 12];
  }

  @Watch('formData', { deep: true })
  onChange() {
    this.$emit('change', this.formData);
  }

  @Watch('businessInfo', { immediate: true })
  fillFormData() {
    if (!this.businessInfo) return;

    this.formData =
      this.defaultFormData && formValidate(this.defaultFormData)
        ? this.defaultFormData
        : this.getInitialFormData();
  }

  getInitialFormData(): ConfigFormData {
    const business = this.businessInfo;

    if (
      !business ||
      !business.coinRewardPercentage ||
      !this.alreadySetRewardRate
    ) {
      return configFormDataFactory();
    }

    const coinPurchasePercent = Number.parseFloat(
      business.coinRewardPercentage
    );

    const valueExists = this.defaultValues.includes(coinPurchasePercent);

    if (!coinPurchasePercent) return configFormDataFactory();

    return Object.assign(this.formData, configFormDataFactory(), {
      value: valueExists ? coinPurchasePercent : 0,
      customValue: !valueExists ? coinPurchasePercent : '',
      type: valueExists ? 'default' : 'custom',
      state: {
        [coinPurchasePercent]: true
      }
    });
  }

  handleClickDefaultRadio(value: number, type: ConfigFormDataValueType) {
    if (this.disabled) return;

    const { state } = this.formData;

    Object.assign(this.formData, { customValue: '' });

    this.$analytics({
      eventCategory: 'Coin & Loyalty Settings - Rewards Rate',
      eventLabel: `Clicked on each of the reward options (${value})`,
      eventAction: 'click'
    });

    if (!state[value]) {
      Object.assign(this.formData, {
        value,
        type,
        state: {
          [value]: true
        }
      });

      return;
    }

    Object.assign(this.formData, configFormDataFactory());
  }

  handleClickCustomRadio(type: ConfigFormDataValueType) {
    if (this.disabled) return;

    this.$analytics({
      eventCategory: 'Coin & Loyalty Settings - Rewards Rate',
      eventLabel: `Clicked on Custom reward`,
      eventAction: 'click'
    });
    Object.assign(this.formData, { type, value: 0, state: {} });
  }

  handleInputStateFocus(focused: boolean, type: string) {
    if (this.disabled) return;

    const { customValue } = this.formData;

    const isFocusOut = !focused;

    if (isFocusOut && customValue <= 0) {
      Object.assign(this.formData, configFormDataFactory());

      return;
    }

    Object.assign(this.formData, {
      customValueFocused: focused,
      type,
      value: 0,
      state: {}
    });
  }
}
